// extracted by mini-css-extract-plugin
module.exports = {"details":"ToggleDetails_details__vhvsb","arrow-icon":"ToggleDetails_arrow-icon__iG3YE","summary":"ToggleDetails_summary__wqgmo","content":"ToggleDetails_content__mzht3"};